import React, { useEffect, useCallback, useContext, useReducer, useState, useRef } from 'react'
import { FormField } from '../../uiwidgets/FormField';
import { FormContainer } from '../../uiwidgets/FormContainer';
import { SubmitButton } from '../../uiwidgets/SubmitButton';
import { Row, Col, Alert, Table, Form, Image, Modal, Card } from 'react-bootstrap';
import PageContentContainer from '../../uiwidgets/PageContentContainer';
import { evenRound } from '../../util/NumberUtils';
import { SecurityContext } from '../../security/SecurityContext';
import { TenantContext } from '../../tenant/TenantContext';
import { isValidUUID, isNumeric } from 'util/Validators';
import { PROFILE_URL } from '../../config/config';
import { API } from '../../api/API';
import { getDonationCauses, calculatedTotalDonationAmount } from './DonationNoLoginService'
import { useReducerAsync } from "use-reducer-async";
import { PaymentCartContext } from 'pages/payment-cart/PaymentCartContext';
import { formatCurrency } from 'util/Currency';
import Button from 'react-bootstrap/Button';
import { getRecipientTypes } from 'util/Lookup';

import { DonationNoLoginFormDataReducer, donationNoLoginFormDataInitialState, AsyncDonationNoLoginFormHandlers } from './DonationNoLoginFormDataReducer';
import { DonationNoLoginFormValidationReducer, donationNoLoginFormValidationInitialState } from './DonationNoLoginFormValidationReducer';
import { validateInput } from './DonationValidationService';
import { isDateGreaterThanMonthMinusTwoDays, isDateGreaterThanYearMinusTwoDays } from 'util/Validators';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faArrowLeft, faArrowRight, faImage, faCartShopping } from '@fortawesome/free-solid-svg-icons'
import { useNavigate, useParams, useLocation, Navigate } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import _ from "lodash";
import { splitCamelCase } from 'util/StringUtils';
import { getSponsorshipTypes } from 'util/Lookup';
import { BUSINESS_DONATION_CAUSES_URL, SPONSORSHIPS_URL } from '../../config/config';
import { stringDateToUTC } from 'util/Date';

function DonationNoLoginPage(props) {
  const [formData, formDispatch] = useReducerAsync(DonationNoLoginFormDataReducer, donationNoLoginFormDataInitialState, AsyncDonationNoLoginFormHandlers);
  const [formValidityData, formValidityDispatch] = useReducer(DonationNoLoginFormValidationReducer, donationNoLoginFormValidationInitialState);
  const secCtx = useContext(SecurityContext);
  const { businessConfig } = useContext(TenantContext);
  const { addToCart, addMultipleToCart } = useContext(PaymentCartContext);
  const navigate = useNavigate();
  const causeAmountFieldRef = useRef(null);
  const sugBtnRef = useRef(null);
  const requestParams = useParams();
  const location = useLocation();


  const donationsCount = formData.donationLineItems.filter(dli => dli.lineItemAmount > 0).length;
  const [showSponsorshipImage, setShowSponsorshipImage] = useState({ show: false, sponsorship: {} });
  const handleSponsorshipImageClose = () => setShowSponsorshipImage({ show: false, sponsorship: {} });
  const handleSponsorshipImageShow = (sponsorship) => {
    setShowSponsorshipImage({ show: true, sponsorship: sponsorship });
  }
  const [showSponsorshipDetail, setShowSponsorshipDetail] = useState({ show: false, sponsorship: {} });
  const handleSponsorshipDetailClose = () => setShowSponsorshipDetail({ show: false, sponsorship: {} });
  const handleSponsorshipDetailShow = (sponsorship) => {
    setShowSponsorshipDetail({ show: true, sponsorship: sponsorship });
  }

  const fetchDonationCauses = useCallback(async () => {
    let isAdmin = secCtx.authState && secCtx.profile.roles.includes("ROLE_BUSINESS_ADMIN");
    let donationCauses = await getDonationCauses(isAdmin);
    let selectedCause = donationCauses.find(dc => dc.donationCauseCode === requestParams.causeCode);
    formDispatch({ type: 'UPDATE_DONATION_ITEMS', payload: { donationCauses, selectedCause: selectedCause } });
    formValidityDispatch({ type: 'UPDATE_DONATIONITEMS_VALIDATION_ERR_MSGS', payload: { donationCauses } });
    if (selectedCause?.id  && selectedCause?.sponsorshipCause) {
      formDispatch({ type: 'FETCH_SPONSORSHIPS', payload: { donationCauseId: selectedCause.id } })
    }

  });


  const onToastClose = () => {
    formDispatch({ type: 'RESET_MESSAGE_AND_ERRORS' });
  }

  useEffect(() => {
    console.log("Fetching donation causes");
    fetchDonationCauses()
      .catch(err => {
        console.log("Error fetching donation causes")
      });

    if (secCtx.authState) {
      API.get(PROFILE_URL).then(resp => {
        let profile = resp.data;
        formDispatch({ type: 'UPDATE_DONOR_DETAILS', payload: { profile } })
      })
    };

  }, []);


  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
    formDispatch({ type: 'FIELD_EDIT', payload: { name: name, value: value } })
  }

  const handleDonationCauseChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    formDispatch({ type: 'DONATION_CAUSE_CHANGE', payload: { selectedDonationCauseId: value } })
  }

  const addDonation = async (checkout) => {
    let isValidToAdd = true
    let addValidationMessage = "";
    if (!isValidUUID(formData.currentDonationCause)) {
      addValidationMessage = "Invalid Donation Cause ID";
      isValidToAdd = false;
      formValidityDispatch({ type: 'VALIDATE_CURRENTDONATIONCAUSE', payload: { ['currentDonationCause']: document.getElementById('currentDonationCause').value } })
    }
    if (!isNumeric(formData.currentDonationCauseValue) || evenRound(parseFloat(formData.currentDonationCauseValue), 2) <= parseFloat(0)) {
      addValidationMessage = "Invalid Donation Value";
      isValidToAdd = false;
      formValidityDispatch({ type: 'VALIDATE_CURRENTDONATIONCAUSEVALUE', payload: { ['currentDonationCauseValue']: document.getElementById('currentDonationCauseValue').value } })
    }
    if (!_.isEmpty(formData.sponsorships) && _.isEmpty(formData.selectedSponsorships)) {
      isValidToAdd = false;
      addValidationMessage = "The selected donation cause requires a sponsorship to be selected"
      formValidityDispatch({ type: 'VALIDATE_SPONSORSHIPS', payload: { sponsorships: formData.sponsorships, selectedSponsorships: formData.selectedSponsorships } })
    }

    //validate end date and frequency
    for (let sps of formData.selectedSponsorships) {
      let { hasError, error } = validateInput('endDate', sps.endDate)
      if (!hasError) {
        if (sps.frequency == 'MONTHLY' && !isDateGreaterThanMonthMinusTwoDays(sps.endDate)) {
          hasError = true;
          error = "End date must be greater than atleast one month for month frequency";
        }
        if (sps.frequency == 'ANNUALLY' && !isDateGreaterThanYearMinusTwoDays(sps.endDate)) {
          hasError = true;
          error = "End date must be greater than atleast one year for anual frequency";
        }
      }
      if (hasError) {
        isValidToAdd = false;
        addValidationMessage = error;
        formValidityDispatch({ type: 'VALIDATE_SPONSORSHIP_ENDDATE', payload: { sponsorship: sps, name: 'endDate', value: sps.endDate } });
        break;
      }
      if (sps.frequency.trim() === "" || (sps.frequency != 'ONE_TIME' && sps.frequency != 'MONTHLY' && sps.frequency != 'ANNUALLY')) {
        isValidToAdd = false;
        addValidationMessage = "One of the Frequencies is invalid"
        break;
      }
    }

    if (!isValidToAdd) {
      alert(addValidationMessage);
      return;
    }

    for (let donationLineItem of formData.donationLineItems) {
      if (donationLineItem.causeId !== formData.currentDonationCause) {
        continue;
      }
      //if there is a sponsorship then override the dliclone lineitemamount and total amount and add each sponsorship to cart
      //as individual items and use sponsorship id then it would be unique in card
      let paymentCartItems = [];
      if (!_.isEmpty(formData.selectedSponsorships)) {
        for (let sps of formData.selectedSponsorships) {
          let totalDonationAmount = 0.00;
          let dliClone = _.cloneDeep(donationLineItem);
          dliClone.lineItemAmount = evenRound(parseFloat(sps.freqAmount) * 100, 2);
          totalDonationAmount = evenRound(parseFloat(sps.freqAmount) * 100, 2);
          dliClone.lineItemDescription = dliClone.lineItemDescription + " " + sps.title;
          dliClone.quantity = 1;
          let spsClone = _.cloneDeep(sps);
          spsClone.maxAmount = evenRound(parseFloat(sps.maxAmount) * 100);
          spsClone.freqAmount = evenRound(parseFloat(sps.freqAmount) * 100);
          spsClone.endDate = sps.endDate ? stringDateToUTC(sps.endDate) : ""
          dliClone.selectedSponsorships = [spsClone];
          paymentCartItems.push({
            id: spsClone.id, commitmentType: 'DONATION',
            itemDetail: {
              donationType: "ACCOUNT",
              amountDue: totalDonationAmount,
              lineItems: [dliClone]
            },
            account: null,
            accountType: null,
            qty: 1
          });
          console.log(paymentCartItems);
        }
        addMultipleToCart(paymentCartItems);
      } else {
        let totalDonationAmount = 0.00;
        let dliClone = _.cloneDeep(donationLineItem);
        dliClone.lineItemAmount = Math.trunc(evenRound(parseFloat(formData.currentDonationCauseValue) * 100, 2));
        totalDonationAmount = evenRound(totalDonationAmount + parseFloat(dliClone.lineItemAmount), 2);
        dliClone.quantity = 1;
        dliClone.lineItemDescription = dliClone.lineItemDescription + " " + formData.causeAttrDescription
        let paymentCartItems = await addToCart(uuidv4(), 'DONATION', {
          donationType: "ACCOUNT",
          amountDue: totalDonationAmount,
          lineItems: [dliClone],
          frequency: formData.currentDonationCauseFrequency
        }, null, null, 1);
        console.log(paymentCartItems);
      }
    }

    if (checkout) {
      navigate('/checkout-form');
    } else {
      formDispatch({ type: 'ADD_TO_CART_SUCCESS' })
    }

  }

  const deleteDonation = (event, causeId) => {
    formDispatch({ type: 'DELETE_DONATION', payload: { causeId: causeId } })
  }

  const handleValidation = (event) => {
    let dispatchType = 'VALIDATE_' + event.target.name.toUpperCase();
    const name = event.target.name;
    const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
    formValidityDispatch({ type: dispatchType, payload: { [name]: value } })
  }

  const fillAmount = (event, donationAmount, causeAttrDescription) => {
    formDispatch({ type: 'FIELD_EDIT', payload: { name: 'currentDonationCauseValue', value: donationAmount } });
    if (!_.isEmpty(causeAttrDescription)) {
      formDispatch({ type: 'FIELD_EDIT', payload: { name: 'causeAttrDescription', value: causeAttrDescription } })
    }
    causeAmountFieldRef.current.focus();

  }

  const handlePaging = async (page) => {
    if (page < 0) {
      alert("Reached the beginning of data set")
      page = 0;
      return;
    }
    if (page > formData.totalPages - 1) {
      alert("Reached the end of data set")
      page = formData.totalPages - 1;
      return;
    }
    formDispatch({ type: 'HANDLE_PAGING', payload: { currentPage: page } });
  }

  const handleFilterKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      formDispatch({ type: 'FETCH_SPONSORSHIPS', payload: { donationCauseId: formData.currentDonationCause } });
    }
  };

  const handleFilter = async (event) => {
    if (formData.readOnly) {
      return;
    }
    const name = event.target.name;
    const value = event.target.value;
    if (value.length > 3) {
      formDispatch({ type: 'FETCH_SPONSORSHIPS', payload: { donationCauseId: formData.currentDonationCause, titleFilter: value } });
    } else {
      formDispatch({ type: 'FIELD_EDIT', payload: { name: name, value: value } })
    }

  }

  const handleSponsorshipSelect = (event, sponsorship) => {
    const name = event.target.name;
    const value = event.target.value;
    formDispatch({ type: 'SELECT_SPONSORSHIP', payload: { sponsorship: sponsorship, check: event.target.checked } })
    formDispatch({ type: 'CALCULATE_TOTAL_AMOUNT' })
    formValidityDispatch({ type: 'VALIDATE_CURRENTDONATIONCAUSEVALUE', payload: { currentDonationCauseValue: sponsorship.maxAmount } })
  }

  const handlePaymentFrequencyChange = (event, sponsorship) => {
    formDispatch({ type: 'SET_SELECTED_SPONSORSHIP_FREQUENCY', payload: { sponsorship: sponsorship, paymentFrequency: event.target.value } })
  }

  const handlePaymentFrequencyValidation = (event) => {

  }

  const handleSponsorshipChange = (event, sponsorship) => {
    const name = event.target.name;
    const value = event.target.value;
    formDispatch({ type: 'HANDLE_SPONSORSHIP_CHANGE', payload: { sponsorship: sponsorship, name: name, value: value } })

  }

  const handleSponsorshipValidation = (event, sponsorship) => {
    const name = event.target.name;
    const value = event.target.value;
    formValidityDispatch({ type: 'VALIDATE_SPONSORSHIP_' + name.toUpperCase(), payload: { sponsorship: sponsorship, name: name, value: value } })

  }

  if (!secCtx.authState && businessConfig.busPmtSrcTypes.length === 1 && businessConfig.busPmtSrcTypes[0].paymentSourceType === "OFFLINE") {
    if (!_.isEmpty(location.pathname) && location.pathname !== "/") {
      return <Navigate to={"/login?redirectTo=" + location?.pathname} replace />;
    } else {
      return <Navigate to={"/login"} replace />;
    }
  } else {
    return (
      <>
        {formData.status && <PageContentContainer>
          <Alert key="warning" variant='warning'>{formData.status}</Alert>
        </PageContentContainer>}

        <FormContainer title="Make a Donation" toastCloseFunc={onToastClose} errors={formData.errors} infoMessage={formData.infoMessage}>
          <Row>
            <Col>
              <ol>
                <li>Choose a donation cause from the "Donation Cause" dropdown.</li>
                {!formData.sponsorshipCause &&
                  <li>Enter a donation amount.</li>}
                {formData.sponsorshipCause &&
                  <li>Select one or more sponsorships from the displayed list at the bottom.</li>}
                <li>Click "Add to Cart" to add multiple donations.</li>
                <li>For direct checkout, click "Add to Cart and Checkout."</li>
                <li>Alternatively, use the Payment Cart icon which appears in top right corner, on adding atleast one donation, to navigate to the Payment screen.</li>
              </ol>
            </Col>
            {false && <Col className="d-flex justify-content-end">
              <div>
                <h6>Total Donation Amount</h6>
                <h3>{formData.totalDonationAmount == null ? "0.00" : formatCurrency(evenRound(formData.totalDonationAmount, 2), businessConfig.locale, businessConfig.currency)}</h3>
                {donationsCount > 0 && <><Button className='mt-1 p-2 btn-fill' variant="info">Pay</Button>&nbsp;&nbsp;&nbsp;
                  <Button className='mt-1 p-2 btn-fill' variant="info">Cart</Button></>}
              </div>
            </Col>}
          </Row>
          <Row>
            {formData.mediaType && <Col className="d-flex justify-content-start" md={4} lg={4} sm={12}>
              <Image src={process.env.REACT_APP_BASE_API_URL + BUSINESS_DONATION_CAUSES_URL + '/' + formData.currentDonationCause + '/img'} fluid />
            </Col>}
            <Col sm={12} md={4} lg={4}>
              <Row>
                <Col>
                  <FormField name="currentDonationCause" label="Donation Cause" type="select" readOnly={formData.readOnly}
                    onChange={handleDonationCauseChange} onBlur={handleValidation} value={formData.currentDonationCause}
                    valstate={!formValidityData.currentDonationCauseError} valMsg={formValidityData.currentDonationCauseErrMsg}>
                    <option value="" key="zeroval"></option>
                    {formData.donationLineItems.map((donationLineItem, idx) => (
                      <option value={donationLineItem.causeId} key={idx}>{donationLineItem.lineItemDescription}</option>
                    ))}
                  </FormField>
                </Col>
              </Row>
              <Row>
                <Col>
                  <FormField name="currentDonationCauseValue" type="text" label="Donation Amount" readOnly={formData.readOnly || formData.sponsorshipCause}
                    onChange={handleChange} onBlur={handleValidation} value={formData.currentDonationCauseValue}
                    valstate={!formValidityData.currentDonationCauseValueError} valMsg={formValidityData.currentDonationCauseValueErrMsg}
                    rref={causeAmountFieldRef} />
                </Col>
              </Row>
              {!formData.sponsorshipCause && <Row>
                <Col>
                  <FormField name="currentDonationCauseFrequency" label="Optional: Select frequency to make this a recurring payment" type="select" readOnly={formData.readOnly}
                    onChange={handleChange} onBlur={handleValidation} value={formData.currentDonationCauseFrequency}
                    valstate={!formValidityData.currentDonationCauseFrequencyError} valMsg={formValidityData.currentDonationCauseFrequencyErrMsg}>
                    <option value="" key="NOVAL">Optional: select Frequency to make recurring</option>
                    <option value="WEEKLY" key="WEEKLY">Weekly</option>
                    <option value="BIWEEKLY" key="BIWEEKLY">Biweekly</option>
                    <option value="MONTHLY" key="MONTHLY">Monthly</option>
                    <option value="ANNUALLY" key="ANNUALLY">Annually</option>
                  </FormField>
                </Col>
              </Row>}
              <Row><Col>&nbsp;</Col></Row>
              <Row>
                <Col>
                  {_.isEmpty(formData.sponsorships) && formData.selectedCauseAttributes && !formData.hasDescription && <>
                    {formData.selectedCauseAttributes.map((causeAttr, idx) => {
                      let donAmount = parseFloat(causeAttr.suggestedAmount) / 100;
                      return (<React.Fragment key={idx}>
                        <Button variant='secondary' className='mt-1 p-2 btn-fill' onClick={event => fillAmount(event, donAmount)}>
                          {formatCurrency(donAmount, businessConfig.locale, businessConfig.currency)}
                        </Button>
                        &nbsp;</React.Fragment>);
                    })}

                    {(formData.selectedCauseAttributes && formData.selectedCauseAttributes.length > 1)
                      && <Button variant='secondary' className='mt-1 p-2 btn-fill' onClick={event => fillAmount(event, "0.00")} key="custamount">Custom Amount</Button>}
                  </>}
                  {_.isEmpty(formData.sponsorships) && formData.selectedCauseAttributes && formData.hasDescription &&
                    <Row>
                      {formData.selectedCauseAttributes.map((causeAttr, idx) => {
                        let donAmount = parseFloat(causeAttr.suggestedAmount) / 100;
                        return (<React.Fragment key={idx}>
                          <Col sm={12} md={12} lg={12}>
                            <Button variant='secondary' className='mt-2 p-2 btn-fill flex-fill w-100' onClick={event => fillAmount(event, donAmount, causeAttr.description)}>
                              {formatCurrency(donAmount, businessConfig.locale, businessConfig.currency)} - {causeAttr.description.toUpperCase()}
                            </Button>
                          </Col>

                        </React.Fragment>);
                      })}

                      {(formData.selectedCauseAttributes && formData.selectedCauseAttributes.length > 1)
                        && <Col sm={12} md={12} lg={12}>
                          <Button variant='secondary' className='mt-2 p-2 btn-fill flex-fill w-100' onClick={event => fillAmount(event, "0.00")} key="custamount">Custom Amount</Button>
                        </Col>}
                    </Row>}
                </Col>
              </Row>
            </Col>
          </Row>

          {(formData.sponsorshipCause || formData.titleFilter) &&
            <React.Fragment>
              <Row>

                <Col mb={4} lg={4} sm={6}><Form.Control name="titleFilter" label="Keyword filter" placeholder="Keyword Filter" type="text" onChange={handleFilter}
                  value={formData.titleFilter}
                  onBlur={handleFilter}
                  onKeyDown={handleFilterKeyDown} />
                </Col>

                <Col className='d-flex justify-content-end'>
                  <Button variant="dark" className="border-0 text-dark" onClick={(event) => { handlePaging(formData.currentPage - 1) }}>
                    <h6><FontAwesomeIcon icon={faArrowLeft} />Previous Page</h6>
                  </Button>
                  &nbsp;<span className="border-0 text-dark btn"><h6>{formData.currentPage + 1} of {formData.totalPages}</h6></span>
                  &nbsp;<Button variant="dark" className="border-0 text-dark" onClick={(event) => { handlePaging(formData.currentPage + 1) }}>
                    <h6>Next Page<FontAwesomeIcon icon={faArrowRight} /></h6>
                  </Button>
                </Col>
              </Row>
              <Row>
                <Col><small><b>Important note for monthly sponsorships: The first monthly sponsorship donation will be deducted immediately upon setup.
                  The next payment date will automatically be set to current numeric day of next month and it will continue on a monthly basis. Use the Recurring Payments Screen if
                  you need to modify the next payment date.</b></small></Col>
              </Row>
              <Row>
                {_.isEmpty(formData.sponsorships) && <Alert variant="warning">No Sponsorships found.</Alert>}
                {!_.isEmpty(formData.sponsorships) && formData.sponsorships.map((sponsorship, idx) => {
                  let firstKey = '';
                  let firstValue = '';
                  if (!_.isEmpty(sponsorship.sponsorshipAttributes)) {
                    const keys = Object.keys(sponsorship.sponsorshipAttributes);
                    if (keys.length > 0) {
                      firstKey = keys[0];
                      firstValue = sponsorship.sponsorshipAttributes[firstKey];
                    }
                  }
                  let isSelected = formData.selectedSponsorships.some(sps => sps.id === sponsorship.id)

                  return (
                    <Col key={idx} xs={12} sm={6} md={3} lg={2}>
                      <Card>
                        {sponsorship.mediaType && <Card.Img src={process.env.REACT_APP_BASE_API_URL + SPONSORSHIPS_URL + '/' + sponsorship.id + '/img'}
                          style={{ height: '230px', maxHeight: '250px', objectFit: 'cover' }} />}
                        {!sponsorship.mediaType && <Card.Img src="/ui/images/no-image.svg"
                          style={{ height: '230px', maxHeight: '250px', objectFit: 'cover' }} />}
                        <Card.Body>
                          <Card.Title style={{ fontWeight: "bold" }}>
                            {sponsorship.title}
                            <FormField name="selectedSponsorships" value={sponsorship.id} type="checkbox"
                              checktype="switch" checked={isSelected}
                              onChange={event => handleSponsorshipSelect(event, sponsorship)} onBlur={handleValidation}
                              valstate={!formValidityData.selectedSponsorshipsError} valMsg={formValidityData.selectedSponsorshipsErrMsg}
                            />
                          </Card.Title>
                          <small>
                            {sponsorship.sponsorshipType === 'RECURRING' && <React.Fragment><Row><Col>
                              <FormField name="paymentFrequency" label={getSponsorshipTypes(sponsorship.sponsorshipType)}
                                type="select" readOnly={formData.readOnly}
                                onChange={event => handlePaymentFrequencyChange(event, sponsorship)} onBlur={handlePaymentFrequencyValidation} value={sponsorship.frequency}
                                valstate={!formValidityData.paymentFrequencyError} valMsg={formValidityData.paymentFrequencyErrMsg}>
                                <option value="MONTHLY" key="MONTHLY">Monthly</option>
                                <option value="ANNUALLY" key="ANNUALLY">Annually</option>
                              </FormField>
                            </Col></Row>
                              <Row><Col>
                                <FormField
                                  name="endDate" type="date" readOnly={formData.readOnly} value={sponsorship.endDate}
                                  label={"sponsorship at " + formatCurrency(sponsorship.freqAmount, businessConfig.locale, businessConfig.currency) + " ending"}
                                  onChange={event => handleSponsorshipChange(event, sponsorship)}
                                  onBlur={event => handleSponsorshipValidation(event, sponsorship)}
                                  valstate={!formValidityData['endDateError' + sponsorship.id]}
                                  valMsg={formValidityData['endDateErrMsg' + sponsorship.id]} />
                              </Col></Row></React.Fragment>}
                            {sponsorship.sponsorshipType === 'ONE_TIME' && <React.Fragment>
                              {getSponsorshipTypes(sponsorship.sponsorshipType) + " sponsorship at " + formatCurrency(sponsorship.freqAmount, businessConfig.locale, businessConfig.currency)}
                            </React.Fragment>}
                          </small>
                        </Card.Body>
                        <Card.Footer>
                          {firstKey && <Button variant="link" className="border-0 text-dark m-0 p-0" onClick={event => handleSponsorshipDetailShow(sponsorship)}>
                            {splitCamelCase(firstKey)}: {firstValue}
                          </Button>}
                        </Card.Footer>
                      </Card>
                    </Col>
                  )
                })}
              </Row>
            </React.Fragment>}
          <Row>
            <Col>
              <Button onClick={event => addDonation(false)} className='btn-fill pull-right m-1' variant="info"
                disabled={formValidityData.currentDonationCauseError || formValidityData.currentDonationCauseValueError}>Add to Cart</Button>
              <Button onClick={event => addDonation(true)} className='btn-fill pull-right m-1' variant="info"
                disabled={formValidityData.currentDonationCauseError || formValidityData.currentDonationCauseValueError}>Add to Cart and Checkout</Button>
            </Col>
          </Row>
        </FormContainer>
        <Modal show={showSponsorshipImage.show} onHide={handleSponsorshipImageClose}>
          <Modal.Header closeButton />
          <Modal.Body>
            {showSponsorshipImage.sponsorship.mediaType &&
              <img src={process.env.REACT_APP_BASE_API_URL + SPONSORSHIPS_URL + '/' + showSponsorshipImage.sponsorship.id + '/img'} />}
            {(!showSponsorshipImage.sponsorship.mediaType) &&
              <>No Image is assinged to this donation cause</>
            }
          </Modal.Body>
        </Modal>
        <Modal show={showSponsorshipDetail.show} onHide={handleSponsorshipDetailClose}>
          <Modal.Header closeButton>{getRecipientTypes(showSponsorshipDetail.sponsorship.recipientType)} Details</Modal.Header>
          <Modal.Body>
            {showSponsorshipDetail.sponsorship.sponsorshipAttributes && Object.entries(showSponsorshipDetail.sponsorship.sponsorshipAttributes).map(([key, value]) => (
              <React.Fragment key={key}>
                <strong key={key}>{splitCamelCase(key)}:</strong> {value} <br />
              </React.Fragment>
            ))}
            {(!showSponsorshipImage.sponsorship.sponsorshipAttributes) &&
              <>No Details availaible for this sponsorship</>
            }
          </Modal.Body>
        </Modal>
      </>
    )
  }
}



export default DonationNoLoginPage;